import { useQuery } from "@tanstack/react-query";
import { OrganizationInvitationDto } from "../../../models/organization/dto/organization.dto";

export const GET_PENDING_INVITATIONS_QUERY_KEY = (organizationId: string) => ['organization', organizationId, 'pendingInvitations'];

/**
 * The org's pending invitations — a CACHE-ONLY query.
 *
 * There is deliberately no `queryFn`: there is no list endpoint for this, and
 * the rows arrive by `setQueryData` from `useGetCurrentOrganization` (which
 * returns `invitations` alongside the organization) and from the two invite
 * mutations. This hook only reads that cache entry.
 *
 * `enabled: false` is what makes that legal. Without it React Query still
 * schedules a fetch on every mount (the default `staleTime` is 0, so a seeded
 * entry is stale immediately), finds no `queryFn`, and puts the query into the
 * error state with `Missing queryFn for queryKey …`. That was invisible for two
 * reasons: the old `placeholderData: []` kept `data` an empty array through the
 * failure, and until `queryClient.ts` gained a `QueryCache.onError` nothing in
 * the dashboard reported a failed read at all. With that handler in place the
 * pre-existing fault would have become a Sentry issue on every render of the
 * organization page.
 */
export const useGetPendingInvitations = (organizationId: string) => {
    return useQuery<OrganizationInvitationDto[]>({
        queryKey: GET_PENDING_INVITATIONS_QUERY_KEY(organizationId),
        enabled: false,
    });
};
